import { action } from 'mobx';
import { RefObject } from 'react';
import * as React from 'react';
import { PageComponent } from '../../../../utils';
import {
  PageProps,
  PageToolEvents,
} from '../../../../constants';
import { TodayWorkTemplate } from './TodayWork.template';
import { InfinityRetrieve } from '../../../../models';
import { Today } from '../../../../utils/time';
import { TodayWorkModel } from './TodayWork.model';
import { GridLayout } from '../../../../components';
import { ConfirmWarning } from '../../../../utils/confirm';

interface TodayWorkState {
  stdate: string;
  kukcd: string;
  divicd: string;
  divinm: string;
  perid: string;
  pernm: string;

  workList: Array<TodayWorkModel>;
}

/*
 * 컨트롤러
 * @window w_tb_e037w_03
 * @category 금일업무내역조회
*/
export class TodayWork extends PageComponent<PageProps, TodayWorkState>
  implements PageToolEvents {
  infinity?: InfinityRetrieve;

  grid: RefObject<GridLayout> = React.createRef();

  constructor(props: PageProps, context: any) {
    super(props, context);
    this.props.onMount && this.props.onMount(this);

    this.state = props.state || {
      stdate: Today.date(),
      kukcd: '02',
      divicd: '',
      divinm: '',
      perid: '',
      pernm: '',

      workList: [],
    };
  }

  @action
  async onFirstOpenEvent() {
    await this.onRetrieveEvent();
  }

  @action
  async onRetrieveEvent() {
    const { actionStore: api } = this.props;

    this.infinity = new InfinityRetrieve(
      {
        stdate: this.state.stdate,
        kukcd: this.state.kukcd,
        divicd: this.state.divicd,
        perid: this.state.perid,
      },
      (params) => api.retrieve(params),
      (items, next) => {
        if (items) {
          this.setState({
            workList: [
              ...this.state.workList,
              ...items.map((x: any) => new TodayWorkModel(x)),
            ],
          }, next);
        }
      },
      async () => {
        await this.SS({
          workList: [],
        });
        await this.infinity?.retrieveAll();
        await this.grid.current?.forceRepaint(true);
        this.grid.current?.setFocus(0);
      },
    );
    await this.SS({
      workList: [],
    });

    await this.infinity?.retrieveAll();
    if (this.state.workList && this.state.workList?.length > 0) {
      this.grid.current?.setFocus(0);
    }
  }

  @action
  async onPrintEvent() {
    const { actionStore: api } = this.props;

    if (this.state.workList.length < 1) {
      ConfirmWarning.show('경고', '출력할 내역이 없습니다');
      return;
    }

    await api.printWithElmanManager({
      stdate: this.state.stdate,
      kukcd: this.state.kukcd,
      divicd: this.state.divicd,
      perid: this.state.perid,
    });
  }

  @action
  async onExcelEvent() {
    const { actionStore: api } = this.props;

    if (this.state.workList.length < 1) {
      ConfirmWarning.show('경고', '엑셀변환할 내역이 없습니다');
      return;
    }

    await api.excel({
      stdate: this.state.stdate,
      kukcd: this.state.kukcd,
      divicd: this.state.divicd,
      perid: this.state.perid,
    });
  }


  render() {
    return (
      <TodayWorkTemplate
        scope={this}
      >
      </TodayWorkTemplate>
    );
  }
}
